import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Component from '../components/done.step.jsx'
import appointmentsActions from '../../activity/actions/appointments'
import {push} from 'react-router-redux'

class Container extends React.Component {

  continue = () => {
    this.props.fetchAppointments()
    this.props.requestNextStep()
    this.props.navigate('/actividad')
  }

  render() {
    return <Component continue={this.continue}/>
  }

  static propTypes = {
    requestNextStep: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    fetchAppointments: PropTypes.func.isRequired,
  }
}

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    navigate: url => dispatch(push(url)),
    fetchAppointments: () => dispatch(appointmentsActions.fetch()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/rentV2/containers/done.js